<template>
  <div>
    <AddDevice
      v-if="addDeviceModal"
      :show="addDeviceModal"
      v-on:closeDeviceModal="addDeviceModal = false"
      v-on:setup-device="setupDevice"
    />
    <CongratulationsModal
      v-if="congratulationsModal"
      :deviceTag="newdeviceTag"
      :show="congratulationsModal"
      v-on:closeCongratulationsModal="congratulationsModal = false"
    />
    <div class="page-wrapper">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>
      <button
        class="btn btn-primary introjs m-2 mr-4 pt-1"
        @click="startIntroJs"
      >
        Tour<i class="font-16 text-warning ml-2 mdi mdi-lightbulb-on"></i>
      </button>
      <div class="page-breadcrumb">
        <div class="col-lg-5 align-self-center">
          <h6 class="page-title">{{ $t("devices") }}</h6>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-3">
            <IconCard
              :label="$t('devices')"
              :title="devicesSummary.devices"
              :iconColor="'background-color: rgba(158, 198, 221, 0.30);'"
            >
              <template slot="icon">
                <IconDevices />
              </template>
            </IconCard>
          </div>
          <div class="col-md-3 col-sm-3">
            <IconCard
              :label="$t('critical')"
              :title="devicesSummary.criticals"
              :iconColor="'background-color: rgba(244, 169, 169, 0.30);'"
            >
              <template slot="icon">
                <IconCritical />
              </template>
            </IconCard>
          </div>
          <div class="col">
            <div class="d-flex align-items-start justify-content-end">
              <a
                href="javascript:void(0)"
                download="devices.csv"
                @click.prevent="exportDevicesCsv"
                ><button class="btn btn-secondary" style="margin-right: 8px">
                  {{ $t("exp-csv") }}
                </button></a
              >
              <div
                data-step="1"
                v-if="profile.role !== 'staff'"
                data-intro="<h5 style='margin-bottom: 1rem; color: #213e7a'>Add a Device</h5>Add devices and track their performances."
                class="text-center"
              >
                <button @click="addDeviceModal = true" class="btn btn-primary">
                  {{ $t("add-device") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid mt-1">
        <div v-if="devices" class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <DevicesTable
                  :stats="sorteddevices"
                  @pageChange="pageChange"
                  :paginationMeta="devicespaginationMeta"
                  @doSearch="doSearch"
                  @sortByStatus="sortDevices"
                  @fetchDevices="fetchDevices"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

import AddDevice from "../Modals/AddDevice";
import CongratulationsModal from "../Modals/CongratulationsModal";
import DevicesTable from "../../components/DevicesTable";
import IconCard from "../../components/IconCard.vue";
import IconDevices from "../../components/Iconsvg/IconDevices.vue";
import IconCritical from "../../components/Iconsvg/IconCritical.vue"


export default {
  name: "Devices",
  components: {
    Loading,
    AddDevice,
    CongratulationsModal,
    DevicesTable,
    IconCard,
    IconDevices,
    IconCritical,
  },
  data() {
    return {
      condition: "all",
      isLoading: true,
      fullPage: true,
      devicesclone: [],
      sorteddevices: [],
      csv: [],
      csvContent: "",
      encodedUri: "",
      Errormssg: "",
      newdeviceTag: "",
      addDeviceModal: false,
      congratulationsModal: false,
    };
  },
  mounted() {
    const params = {
      limit: 10,
      page: 1,
      status: this.getCondition ? [this.getCondition] : undefined,
    };
    this.fetchGroups();
    this.fetchDevicesSummary();
    this.fetchallDevices(params)
      .then(() => {
        this.fetchDeviceCB();
        this.clearCondition();
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg =
          error.response.data.message[0].toUpperCase() +
          error.response.data.message.slice(1);
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
  },
  computed: {
    ...mapGetters([
      "devices",
      "profile",
      "lastPageData",
      "devicespaginationMeta",
      "devicesSummary",
      "getCondition",
    ]),
  },
  methods: {
    ...mapActions([
      "fetchallDevices",
      "updatePageNumber",
      "fetchGroups",
      "fetchSearchedDevices",
      "fetchDevicesSummary",
      "clearCondition",
    ]),
    startIntroJs() {
      // introJs().start();
    },
    doSearch(param, searchQuery) {
      let params = {
        ...param,
        keyword: searchQuery,
      };
      this.isLoading = true;
      this.fetchSearchedDevices(params).then(() => {
        this.fetchDeviceCB();
      });
    },
    setupDevice(devicetag) {
      this.newdeviceTag = devicetag;
      this.congratulationsModal = true;
    },
    sortDevices(params) {
      this.isLoading = true;
      this.fetchallDevices(params)
        .then(() => {
          this.fetchDeviceCB();
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error sorting devices:", error);
        });
    },
    fetchDeviceCB() {
      this.devicesclone = this.devices;
      this.sorteddevices = this.devices;
      this.isLoading = false;
    },
    pageChange(params) {
      this.isLoading = true;
      this.fetchallDevices(params).then(() => {
        this.fetchDeviceCB();
      });
    },
    fetchDevices(params) {
      this.isLoading = true;
      this.fetchallDevices(params).then(() => {
        this.fetchDeviceCB();
      });
    },
    exportDevicesCsv() {
      const csvHead = [
        [
          this.$t("device_id"),
          this.$t("imei"),
          this.$t("status"),
          this.$t("device_name"),
          this.$t("temperature"),
          this.$t("humidity"),
          this.$t("battery"),
          this.$t("last_seen_day"),
          this.$t("date"),
          this.$t("time"),
          this.$t("transmission"),
        ],
      ];
      for (let i = 0; i < this.devicesclone.length; i++) {
        let date = moment(this.devicesclone[i].stat?.createdAt).format(
          "ddd, MMM Do YYYY, hh:mm a"
        );
        let data = [
          this.devicesclone[i]?.deviceTag,
          this.devicesclone[i]?.imei,
          this.devicesclone[i].status,
          this.devicesclone[i]?.settings?.name,
          this.devicesclone[i]?.stat?.temperature,
          this.devicesclone[i]?.stat?.humidity,
          this.devicesclone[i]?.stat?.battery,
          date,
          this.devicesclone[i]?.isTransmissionEnabled ? "Enabled" : "Disabled",
        ];
        this.csv.push(data);
      }
      this.csv = csvHead.concat(this.csv);
      this.csv = this.csv.map((e) => e.join(",")).join("\n");
      this.csvContent = "data:text/csv;charset=utf-8," + this.csv;
      this.encodedUri = encodeURI(this.csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", this.encodedUri);
      link.setAttribute("download", "devices.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.csv = [];
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== "DeviceDetails")
      this.updatePageNumber({
        lastPageNumber: 1,
        lastPage: ``,
        lastPageName: "",
      });
    next();
  },
};
</script>
<style scoped>
.introjs {
  position: fixed;
  top: 0.3rem;
  right: 12rem;
  z-index: 60;
}
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
</style>
